import { jsx as _jsx } from "react/jsx-runtime";
import { fontColors, getInitials, profileColors } from '@sphereon/ui-components.core';
import { SSIProfileIconContainerStyled as Container } from '../../../../styles/components/components/SSIProfileIcon';
import { SSITextH2Styled as ProfileIconText } from '../../../../styles/components';
const ProfileIcon = (props) => {
    const { fontColor = fontColors.light, backgroundColor = profileColors['100'], fullName } = props;
    return (_jsx(Container, { style: { backgroundColor }, children: _jsx(ProfileIconText, { style: { color: fontColor }, children: getInitials(fullName) }) }));
};
export default ProfileIcon;
